import { render, staticRenderFns } from "./ImportQrPage.vue?vue&type=template&id=1bdb4498"
import script from "./ImportQrPage.vue?vue&type=script&lang=js"
export * from "./ImportQrPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports